import { cx } from 'linaria';
import { useSmoothScroll } from '@uds/smooth-scroll';
import { classNames } from '@uds/typography';
import './textbutton.stylesheet_1j82i3v.css';
import { jsx } from 'react/jsx-runtime';

let Size;
(function (Size) {
  Size["SM"] = "SM";
  Size["MD"] = "MD";
  Size["LG"] = "LG";
  Size["INHERIT"] = "INHERIT";
})(Size || (Size = {}));
let ContentType;
(function (ContentType) {
  ContentType["DEFAULT"] = "DEFAULT";
  ContentType["PHONE_NUMBER"] = "PHONE_NUMBER";
})(ContentType || (ContentType = {}));

const root = "rikpgs2";
const uppercase = "u1b2w47q";
const fullWidth = "f1r6ogii";
const fontSize = {
  SM: "s1xk4xcs",
  MD: "mwjiera",
  LG: "l1lg6hji",
  INHERIT: "ixdd31v"
};
const borderWidth = {
  DEFAULT: "d8fddm",
  PHONE_NUMBER: "pfwn6yl"
};
const inner = "i169h6i8";
const getClassNames = _ref => {
  let {
    block,
    size,
    caps,
    contentType
  } = _ref;
  return {
    root: cx(root, classNames.content, caps && uppercase, block && fullWidth, size != null && fontSize[size]),
    inner: cx(inner, contentType != null && borderWidth[contentType])
  };
};

const TextButton = _ref => {
  let {
    disabled = false,
    block = false,
    caps = false,
    size = Size.MD,
    contentType = ContentType.DEFAULT,
    children,
    href,
    className,
    onClick,
    ...domProps
  } = _ref;
  const classNames = getClassNames({
    block,
    disabled,
    size,
    caps,
    contentType
  });
  const Component = href == null ? 'button' : 'a';
  const isAnchor = href != null && href.charAt(0) === '#';
  const smoothScroll = useSmoothScroll();
  const handleClick = event => {
    if (disabled) {
      event.preventDefault();
    } else {
      if (isAnchor) {
        event.preventDefault();
        smoothScroll(href);
      }
      if (onClick) {
        onClick(event);
      }
    }
  };
  return /*#__PURE__*/jsx(Component, {
    className: cx(classNames.root, className),
    href: href,
    "aria-disabled": disabled,
    onClick: handleClick,
    ...domProps,
    children: /*#__PURE__*/jsx("span", {
      className: classNames.inner,
      children: children
    })
  });
};
TextButton.displayName = 'TextButton';
var TextButton$1 = TextButton;

export { ContentType, Size, TextButton$1 as default };
